import React, { useEffect, useRef, useState, useCallback } from 'react';
import {
  checkReportIdWithName,
  getDashboardType,
  getPathFromDashboard,
} from '@/pages/dashboard/utils/utils';
import {
  LOG_SYSTEM_TYPE,
  PAGE_TYPE_AUTH_PATH,
} from '@/pages/dashboard/_config/constant';
import Permission from '@/pages/dashboard/components/NoPermission';
import Loading from '@/pages/dashboard/components/Loadings';
import { IframeUrl } from '@/pages/home/components/IframeUrl';
import { useParams, useSelector } from 'umi';
import { buriedPoint } from '@/pages/home/utils/buriedPoint';
import { getAuthToken } from '@/pages/dashboard/services/dashboard';

interface ReportInfoType {
  loading: boolean;
  error: string;
  authUrl: string;
}

const INIT_REPORT_INFO: ReportInfoType = {
  loading: false,
  error: '',
  authUrl: '',
};



export default () => {
  const [reportInfo, setReportInfo] = useState<ReportInfoType>(INIT_REPORT_INFO);
  const dashboardRef = useRef<any>(null);
  const { reportId } = useParams() as any;
  const { currentMenu, currentGame } = useSelector((state: any) => {
    const { currentMenu, currentGame } = state.dashboard;
    return { currentMenu, currentGame };
  });

  const setState = useCallback((params: Partial<ReportInfoType> = {}) => {
    setReportInfo({
      ...INIT_REPORT_INFO,
      ...params,
    });
  }, []);

  const openAuthReport = useCallback(async () => {
    if (!reportId) {
      setState({ error: '未获取到报表信息' });
      return;
    }
    if (!currentGame) {
      setState({ error: '未获取到游戏信息' });
      return;
    }
    if (
      !currentMenu ||
      getDashboardType(currentMenu) !== PAGE_TYPE_AUTH_PATH ||
      !checkReportIdWithName(reportId, currentMenu?.name_en)
    ) {
      setState({ error: '未匹配到AuthPath菜单' });
      return;
    }
    const { path, id = '', u_id: uId = '', page_type: pageType = PAGE_TYPE_AUTH_PATH } = currentMenu;
    const authPath = `${path || ''}`.trim();
    if (!authPath) {
      setState({ error: '未获取到报表URL' });
      return;
    }
    setState({ loading: true });
    dashboardRef.current = currentMenu;
    try {
      const { game_code: gameCode } = currentGame;
      const result = await getAuthToken({
        res_id: 'dashboard_pc',
        game_code: gameCode,
        menu_id: id || uId,
        page_type: pageType,
        page_value: authPath,
        studio_code: '',
      });
      if (dashboardRef.current?.id !== currentMenu?.id) return;
      const token = result?.data?.token;
      if (!token) {
        setState({ error: '获取鉴权token失败' });
        return;
      }
      const connector = authPath.includes('?') ? '&' : '?';
      const proxyUrl = `${authPath}${connector}token=${encodeURIComponent(token)}`;
      setState({ authUrl: proxyUrl });
      // 打点
      const { id: pageId = '', name_en: nameEn } = currentMenu || {};
      buriedPoint({
        pageId,
        menuId: pageId,
        pageName: nameEn,
        extInfo: nameEn,
        pagePath: getPathFromDashboard(currentMenu),
        uid: gameCode,
        typeId: LOG_SYSTEM_TYPE,
      });
    } catch (err) {
      if (dashboardRef.current?.id !== currentMenu?.id) return;
      setState({ error: '获取鉴权信息失败' });
    }
  }, [reportId, currentGame, currentMenu, setState]);

  useEffect(() => {
    openAuthReport();
  }, [openAuthReport]);

  if (reportInfo.loading) {
    return <Loading />;
  }

  if (reportInfo.error) {
    return <Permission type="error" textCN={reportInfo.error} />;
  }

  return (
    <>
      <IframeUrl url={reportInfo.authUrl} />
    </>
  );
};
